export default function reducer(state, { type, data }) {
  switch (type) {
    case "SET_STICKY":
      return {
        ...state,
        stickyHeight: data,
        isSticky: true
      };
    case "SET_SCROLL":
      return {
        ...state,
        stickyHeight: 0,
        isSticky: false
      };
    case "SET_BOTTOM_FIXED_HEIGHT":
      return {
        ...state,
        bottomFixedHeight: data
      };
    default:
      return state;
  }
}
